import { FilterType } from '@/types/asset-search.types';
import ListView, { ListViewItem } from '@ingka/list-view';
import { translate } from '@repo/phrase';

import { useSearch } from '@/components/filters/search/search.hooks';

export const TypeFilter = () => {
    const { addFilter, removeFilter, typeFilter } = useSearch();
    const selectedFilter = typeFilter;

    const handleFilterChange = (type: string, event: React.FormEvent) => {
        // oxlint-disable-next-line @typescript-eslint/consistent-type-assertions
        const checked = (event.target as HTMLInputElement).checked;

        if (checked) {
            selectedFilter.push(type);
            addFilter(FilterType.Type, selectedFilter.join('_'));
        } else {
            const deleted = selectedFilter.filter((filter) => filter !== type);

            if (deleted.length === 0) {
                removeFilter(FilterType.Type);
            } else {
                addFilter(FilterType.Type, deleted.join('_'));
            }
        }
    };

    return (
        <ListView id="type-filter" data-testid="type-filter" size="small">
            <ListViewItem
                inset
                title={translate('filter_type_order')}
                control="checkbox"
                name="filter-type-order"
                onChange={(event) => {
                    handleFilterChange('order', event);
                }}
                controlProps={{
                    value: translate('filter_type_order'),
                    checked: typeFilter.includes('order'),
                }}
            />
            <ListViewItem
                inset
                title={translate('filter_type_quote')}
                control="checkbox"
                name="filter-type-quote"
                onChange={(event) => {
                    handleFilterChange('quote', event);
                }}
                controlProps={{
                    value: translate('filter_type_quote'),
                    checked: typeFilter.includes('quote'),
                }}
            />
            <ListViewItem
                inset
                title={translate('filter_type_draft')}
                control="checkbox"
                name="filter-type-draft"
                onChange={(event) => {
                    handleFilterChange('draft', event);
                }}
                controlProps={{
                    value: translate('filter_type_draft'),
                    checked: typeFilter.includes('draft'),
                }}
            />
        </ListView>
    );
};
